import { Button, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import useAlertStore from "../../../stores/useAlertStore";
import useWaiverStore from "../../../stores/useWaiverStore";
import update from "../../../api/auth/waivers/update";
import create from "../../../api/auth/waivers/create";
import WushTextField from "../WushTextField";
import ReactQuill from "react-quill";

export default function WaiverForm({ waiver, afterUpdate, afterCreate }) {
  const { register, handleSubmit, setValue, formState: { isDirty } } = useForm({
    defaultValues: {
      name: waiver?.name,
      description: waiver?.description,
      content: waiver?.content
    }
  });

  const { setAlertMessage } = useAlertStore();

  const { updateWaiver, addWaiver } = useWaiverStore();

  const onSubmit = (data) => {
    if(waiver?.id) {
      update(waiver.id, data, (response) => {
        updateWaiver(response);
        setAlertMessage("Item updated successfully", "success");
        afterUpdate && afterUpdate(response);
      }, (error) => {
        console.log(error);
      });
    } else {
      create(data, (response) => {
        addWaiver(response);
        afterCreate && afterCreate(response);
      }, (error) => {
        console.log(error);
      });
    }
  };

  return (
    <Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={2}>
          <Stack>
            <WushTextField label="Name" formRegistration={register("name")} />
          </Stack>
          <Stack>
            <WushTextField label="Description" formRegistration={register("description")} />
          </Stack>
          <Stack>
            <ReactQuill
              theme="snow"
              value={waiver?.content}
              onChange={(value) => setValue("content", value, { shouldDirty: true})}
            />
          </Stack>
          <Stack>
            <Button disabled={!isDirty} variant="contained" type="submit">{waiver?.id ? "Update" : "Create"}</Button>
          </Stack>
        </Stack>
      </form>
    </Stack>
  );
}